import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import $ from "jquery";
import SettingsPopUp from "./SettingsPopUp.js";
import { confirmAlert } from "react-confirm-alert"; // Import

const SettingsReserviertZeitTable = (props) => {
  const { t } = useTranslation();

  let link = localStorage.getItem("link");

  let data = props.data;
  let type = props.type;

  const [reservZeits, setReservZeits] = useState();
  const [popUpShow, setPopUpShow] = useState(false);
  const [currentReservZeitData, setCurrentReservZeitData] = useState();
  const popUpContainer = useRef(null);
  const [top, setTop] = useState(null);

  const openChild = () => {
    const scrollTop = props.getScrollTop();
    setTop(scrollTop + 20);
  };

  const closeChild = () => setTop(null);
  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    await axios
      .get(link + "/api/" + type + "/reservation-timer?elementId=" + data.id)
      .then((response) => {
        setReservZeits(response.data);
      });
  }

  $(document).on("click", function (e) {
    if (
      (popUpContainer.current && e.target.id == "cancelSubmitButton") ||
      (popUpContainer.current &&
        !popUpContainer.current.contains(e.target) &&
        e.target.id != "settings-icon" &&
        !$(e.target).is(".settings-item") &&
        !$(e.target).children().hasClass("settings-item") &&
        !$(e.target).hasClass("select-icon") &&
        !$(e.target).parents(".rc-time-picker-panel").length == 1 &&
        !$(e.target).hasClass("rc-time-picker-clear") &&
        !$(e.target).hasClass("rc-time-picker-clear-icon") &&
        e.target.id != "pop-up-button")
    ) {
      setPopUpShow(false);
      closeChild();
    }
  });

  function editCreateReservZeit(reservZeitData, elementId) {
    reservZeitData.elementId = elementId;
    setCurrentReservZeitData(reservZeitData);
    openChild();
    setPopUpShow(true);
  }

  const deleteReservZeit = (reservZeitData) => {
    let timerId = reservZeitData.timerId;

    confirmAlert({
      message: t("allgemein.bestaetigen"),
      buttons: [
        {
          label: t("allgemein.ja"),
          onClick: () =>
            axios
              .delete(
                link + "/api/" + type + "/reservation-timer?timerId=" + timerId
              )
              .then((response) => {
                getData();
              })

              .catch((error) => {}),
        },
        {
          label: t("allgemein.nein"),
        },
      ],
    });
  };

  function reservZeitsList() {
    let reservZeitsList = [];

    for (let i = 0; i < reservZeits.length; i++) {
      const daysOfWeek = [
        t("allgemein.tageKurz.Sunday"),
        t("allgemein.tageKurz.Monday"),
        t("allgemein.tageKurz.Tuesday"),
        t("allgemein.tageKurz.Wednesday"),
        t("allgemein.tageKurz.Thursday"),
        t("allgemein.tageKurz.Friday"),
        t("allgemein.tageKurz.Saturday"),
      ];
      const chosenDaysOfWeek = reservZeits[i].weekdays
        .map(function (v, i) {
          return daysOfWeek[v];
        })
        .join(",");

      reservZeitsList.push(
        <tr key={"key_" + i}>
          <td>
            {reservZeits[i].startTime} - {reservZeits[i].endTime}
          </td>
          <td>{chosenDaysOfWeek}</td>
          <td>{t("allgemein.an")}</td>
          <td>
            <button
              className="button"
              id="pop-up-button"
              style={{ width: "100px" }}
              onClick={() => editCreateReservZeit(reservZeits[i], data.id)}
            >
              {t("allgemein.bearbeiten")}
            </button>
            <button
              className="button"
              id="pop-up-button"
              style={{ width: "100px", marginLeft: "0" }}
              onClick={() => deleteReservZeit(reservZeits[i])}
            >
              {t("allgemein.loeschen")}
            </button>
          </td>
        </tr>
      );
    }

    return <tbody>{reservZeitsList}</tbody>;
  }

  function popUpChange() {
    getData();
    setPopUpShow(false);
    closeChild();
  }

  return (
    <>
      {popUpShow == true && top !== null && (
        <div ref={popUpContainer}>
          {
            <SettingsPopUp
              popUpType={"reservZeit"}
              type={type}
              data={currentReservZeitData}
              onChange={popUpChange}
              top={top}
            >
              {" "}
            </SettingsPopUp>
          }
        </div>
      )}
      <div className="settings-groups">
        <div className="settings-name">
          {t("lot.reserviert")} {t("allgemein.zeitsteuerung")}
        </div>
        <table id="barrierTable">
          <thead>
            <tr>
              <th>{t("allgemein.zeitraum")}</th>
              <th>{t("allgemein.wochentage")}</th>
              <th>{t("lot.reserviert")}</th>
              <th>
                <button
                  className="button"
                  id="pop-up-button"
                  style={{ width: "50px" }}
                  onClick={() => editCreateReservZeit({}, data.id)}
                >
                  {t("allgemein.neu")}
                </button>
              </th>
            </tr>
          </thead>
          {reservZeits && reservZeitsList()}
        </table>
      </div>
    </>
  );
};

export default SettingsReserviertZeitTable;
